import type { ReactNode } from 'react';

/** Every state before a company is open -- signed out, signing in, adding a
 *  company, a link to a company this browser has not added, offline. One
 *  title, one short explanation, one way forward. */
export function Board({
  title,
  busy,
  centered,
  children,
}: {
  title: string;
  busy?: boolean;
  /** Vertically centred in the window rather than near its top. */
  centered?: boolean;
  children: ReactNode;
}) {
  return (
    <div className={centered ? 'board-ground board-ground-centered' : 'board-ground'}>
      <section className="board" aria-busy={busy || undefined}>
        <h1 className="board-title">{title}</h1>
        {children}
      </section>
    </div>
  );
}
